/** Hide disconnected setup slots; retain offboarded WhatsApp accounts for recovery. */
export function isChannelVisibleInSettings(provider: string, status: string): boolean {
  return status !== 'disconnected' || provider === 'whatsapp'
}
